import React, {useState} from 'react'

export const StoreContext = React.createContext(null);

export default ({children}) => {
  const [isOnline, setIsOnline] = useState(false);

  const store = {
    online: [isOnline, setIsOnline],
  }
  return <StoreContext.Provider value={store}>{children}</StoreContext.Provider>
}